import { Action } from 'history';
import { useCallback } from 'react';
import { BlockerFunction, useBlocker } from 'react-router-dom';
import { routes } from 'router/routes';
import { normalizeURLPath } from 'utils/url';
export const useSignupNavigationGuard = (onBack?: () => void) => {
  const blocker: BlockerFunction = useCallback(({ historyAction, currentLocation, nextLocation }) => {
    const from = normalizeURLPath(currentLocation.pathname);
    const to = normalizeURLPath(nextLocation.pathname);

    if (historyAction === Action.Pop) {
      // From filters to anywhere
      if (from === normalizeURLPath(routes.signupDirect.filters)) {
        return true;
      }

      // Anywhere to filters
      if (to === normalizeURLPath(routes.signupDirect.filters)) {
        onBack?.();
        return false;
      }

      // Allow to go back to landing page (unless its from filters which means forward navigation)
      if (
        from !== normalizeURLPath(routes.signupDirect.filters) &&
        to === normalizeURLPath(routes.signupDirect.landingPage)
      ) {
        onBack?.();
        return false;
      }

      // From eval form details to single
      if (
        from === normalizeURLPath(routes.signupDirect.evaluation.details) &&
        to === normalizeURLPath(routes.signupDirect.evaluation.schedule.single)
      ) {
        onBack?.();
        return false;
      }

      // From 1st split to single
      if (
        from === normalizeURLPath(routes.signupDirect.evaluation.schedule.split.first) &&
        to === normalizeURLPath(routes.signupDirect.evaluation.schedule.single)
      ) {
        onBack?.();
        return false;
      }

      // From single schedule to split 1st
      if (
        from === normalizeURLPath(routes.signupDirect.evaluation.schedule.single) &&
        to === normalizeURLPath(routes.signupDirect.evaluation.schedule.split.first)
      ) {
        onBack?.();
        return false;
      }

      // From split 2nd to split 1st
      if (
        from === normalizeURLPath(routes.signupDirect.evaluation.schedule.split.second) &&
        to === normalizeURLPath(routes.signupDirect.evaluation.schedule.split.first)
      ) {
        onBack?.();
        return false;
      }

      // From eval form details to split 2nd
      if (
        from === normalizeURLPath(routes.signupDirect.evaluation.details) &&
        to === normalizeURLPath(routes.signupDirect.evaluation.schedule.split.second)
      ) {
        onBack?.();
        return false;
      }

      // Default - block
      return true;
    }

    return false;
  }, []);

  const { reset } = useBlocker(blocker);

  reset?.();
};
